import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import type { ChatHost } from "@/features/chat/chatHost";
import { isBuildEntity } from "./examplePrompts";

/**
 * What Build with AI changes on the chat page (ChatPage with the build host); null for a plain chat.
 * `/build/with-ai?entity=agent` (from an entity's "Build with AI") starts a new chat on that kind: the start
 * screen shows its examples and the composer its first sentence.
 */
export function useBuildChat(host: ChatHost, sessionUuid: string | undefined) {
  const { t } = useTranslation("buildChat");
  const [searchParams] = useSearchParams();
  if (host.kind !== "build") return null;
  const param = searchParams.get("entity");
  const entity = !sessionUuid && isBuildEntity(param) ? param : null;
  return {
    entity,
    seed: entity ? t(`seed.${entity}`) : "",
    newChatTitle: t("header.newChat"),
    rootLabel: t("header.root"),
    placeholder: t("composer.placeholder"),
  };
}
